import { trackEvent } from '../../../helpers/analytics/trackEvent';

export const trackNearbyWatersClicked = (searchTerm: string): void => {
  void trackEvent({
    name: 'mykiss_search_nearby_selected',
    properties: { search_term: searchTerm },
  });
};
